import actions from '../actions/landing';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;
